let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cNE5I")).then(() => parcelRequire('5DnPR'));